import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70493440")

_pushScopeId("data-v-70493440")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("TODOを追加")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("複数追加 ")
const _hoisted_5 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_6 = { class: "flex flex-row items-center gap-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" TODOを追加 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "タイトル",
          name: "title",
          type: "text",
          placeholder: "タイトルを記入してください。",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.titles[0] = $event))
        })
      ]),
      (_ctx.titles.length === 1)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", {
              class: "flex flex-row items-center w-fit leading-7 text-md font-medium text-gray-500 cursor-pointer",
              onClick: _cache[2] || (_cache[2] = 
            () => {
              _ctx.titles[1] = '';
            }
          )
            }, [
              _createVNode(_component_m_icon, {
                type: "plus",
                width: "4"
              }),
              _hoisted_4
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.titles, (title, i) => {
        return (_openBlock(), _createBlock("div", { key: i }, [
          (i !== 0)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_m_icon, {
                    type: "plus",
                    width: "4",
                    size: "6",
                    class: "text-gray-500 cursor-pointer",
                    onClick: 
                () => {
                  if (_ctx.titles.length - 1 === i) {
                    _ctx.titles[i + 1] = '';
                  }
                }
              
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_m_text_field, {
                    label: "",
                    name: "title",
                    type: "text",
                    placeholder: "タイトルを記入してください。",
                    value: _ctx.titles[i],
                    onInput: ($event: any) => (_ctx.titles[i] = $event)
                  }, null, 8, ["value", "onInput"]),
                  _createVNode(_component_m_icon, {
                    type: "close",
                    width: "4",
                    size: "6",
                    class: "text-gray-500 cursor-pointer",
                    onClick: 
                () => {
                  _ctx.titles.splice(i, 1);
                }
              
                  }, null, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    footer: _withId(() => [
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.addTodo
      }, {
        default: _withId(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
})